import React, { useEffect, useRef, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext, StatusCodeActive, StatusCodeDelete } from "utils/Constant";
import { ApiCreateReseller, ApiDeleteReseller, ApiGetCustomerList, ApiGetResellerList } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Select from 'react-select'
import SaveButton from "components/Button/SaveButton";
import { FilterCard, FormCard, GridDeleteButton, MainBodyCard, PagesFormTitle, PagesTitle } from "components/Cards";
import { useModal } from "utils/context/ModalContext";
import DataTable from "components/DataTable";
import { ResellerService } from "services/ResellerService/ResellerService";
import { CustomerService } from "services/CustomerService/CustomerService";
import Pagination from "components/Input/PaginationButton";

export default function Reseller(){
    const firstLoad = useRef(true)
    const debounceRef = useRef(null)

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchResellerList, fetchCreateReseller, fetchDeleteReseller } = ResellerService()
    const { fetchCustomerList } = CustomerService()

    // const { data: resellerList, fetch: getResellerList } = useFetch(ApiGetResellerList)
    // const { fetch: getCustomerList } = useFetch(ApiGetCustomerList)
    // const { fetch: createReseller } = useFetch(ApiCreateReseller)
    // const { fetch: deleteReseller } = useFetch(ApiDeleteReseller)


    const [resellerName, setResellerName] = useState(EmptyString)
    const [customerId, setCustomerId] = useState(EmptyString)

    const [customerOptions, setCustomerOptions] = useState([])

    // DATA
    const [resellerList, setResellerList] = useState([])

    
    const resellerNameChange = (e) => {setResellerName(e.target.value)}
    const customerChange = (e) => {setCustomerId(e)}

    // GRID
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchResellerList(
                resellerName,
                PageSize,
                parseInt(newIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setResellerList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "resellerName",
            header: "Nama Reseller"
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridDeleteButton onClick={() => deleteBtnClick(row.resellerId)} size="w-3" />
                </div>
            ),
        },
    ]

    

    

    // Function Api Call
    // async function fGetResellerList(index){
    //     let res

    //     await getResellerList({
    //         data: {
    //             resellerName: resellerName,
    //             pageSize: PageSize,
    //             pageIndex: parseInt(index)
    //         }
    //     }).then((response) => {
    //         if(response.status === ApiResponseSuccess){
    //             res = response
    //         }else if(response.status === ApiResponseStatusUnauthorized){
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                         window.location.href = "/login"
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }else{
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }
    //     })

    //     return res
    // }
    // async function fDeleteReseller(resellerId){
    //     await deleteReseller({
    //         data: {
    //             resellerId: resellerId
    //         }
    //     }).then((response) => {
    //         if(response.status === ApiResponseSuccess){
    //             setSuccessModal({ isOpen: true, data: { onSuccess: async () => { setSuccessModal({  isOpen: false }) }} })
    //         }else if(response.status === ApiResponseStatusUnauthorized){
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                         window.location.href = "/login"
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }else{
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }
    //     })
    // }
    const getCustomerList = async () => {
        const res = await fetchCustomerList(
            EmptyString,
            EmptyString, 
            EmptyString,
            StatusCodeActive,
            10000,
            0
        )
        if (!res) return

        const data = res.data.listData
        const options = data.map((item) => ({ label: item.customerName.toUpperCase(), value: String(item.customerId) }))

        setCustomerOptions(options)
        setCustomerId(options[0].value)
    }
    // async function fCreateReseller(){
    //     await createReseller({
    //         data: {
    //             customerId: customerId.value
    //         }
    //     }).then((response) => {
    //         if(response.status === ApiResponseSuccess){
    //             setSuccessModal({ isOpen: true, data: { onSuccess: async () => { 
    //                 setSuccessModal({isOpen: false})
    //                 // navigate("/customer-card") 
    //             }} })
    //         }else if(response.status === ApiResponseStatusUnauthorized){
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                         window.location.href = "/login"
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }else{
    //             setFailModal({
    //                 isOpen: true,
    //                 data: {
    //                     onSuccess: async () => {
    //                         setFailModal({isOpen: false})
    //                     }
    //                 },
    //                 message: response.message
    //             })
    //         }
    //     })
    // }

    const deleteBtnClick = async (resellerId) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            try {
                showLoading()

                const res = await fetchDeleteReseller(resellerId)
                if (!res) return
                
            } finally {
                hideLoading()

                showSuccess({
                    onSuccess: async () => {
                        await handlePageChange(pageIndex)
                    }
                })
            }
        }
    }
    const saveBtnClick = async () => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            try {
                showLoading()

                const res = await fetchCreateReseller(customerId)
                if (!res) return

            } finally {
                hideLoading()

                showSuccess({
                    onSuccess: async() => {
                        setCustomerId({label: "Select Customer", value: ""})
                        await handlePageChange(pageIndex)
                    }
                })
            }
        }
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                if (firstLoad.current) {
                    await getCustomerList()
                    await handlePageChange(0)

                    firstLoad.current = false
                }
                else {
                    if (debounceRef.current) {
                        clearTimeout(debounceRef.current)
                    }
            
                    debounceRef.current = setTimeout(async () => {
                        await handlePageChange(0)
                    }, 500)
                }
            } finally {
                hideLoading()
            }
        }

        onLoad()
    },[resellerName])

    return(
        <MainBodyCard>
            <PagesTitle title='Reseller' />

            <div className="bg-white p-4 rounded shadow-sm">
                <span className="font-semibold text-xl">Add Reseller</span>

                <FormCard title='Reseller'>
                    <Select options={customerOptions} value={customerOptions.find(x => x.value === customerId)} onChange={(e) => setCustomerId(e.value)} placeholder={"Select Customer"} />
                </FormCard>
                
                <div>
                    <SaveButton onClick={saveBtnClick} visible={true} />
                </div>
            </div>

            <div className="bg-white p-4">
                <div>
                    <span className="font-semibold text-xl">Reseller List</span>
                </div>

                <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                    <FilterCard title='Reseller Name'>
                        <input className="input" value={resellerName} onChange={(e) => setResellerName(e.target.value)} />
                    </FilterCard>
                </div>
            
                <div className="mt-5">
                    <DataTable
                        columns={columns}
                        data={resellerList?.data?.listData ?? []}
                    />
                </div>
            </div>
            
            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </MainBodyCard>
    )
}